import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { signup } from '../store/auth.slice'
import { useAppDispatch } from '../hooks'
import { Spinner } from '../components/spinner'
import { Status } from '../components/status'
import { Logo } from '../assets/logo'
import { NewUserDto } from '../utils/types/auth'

// TODO check if addr empty

const MIN_PASSWORD_LENGTH = 6

export const SignUpView = () => {
  const [newUser, setNewUser] = useState<NewUserDto>({
    email: '',
    password: ''
  })
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [requestState, setRequestState] = useState({ error: '' })
  const inputRef = useRef<HTMLInputElement>(null)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const defaultEmail = searchParams.get('addr')

  useEffect(() => {
    defaultEmail && setNewUser({ ...newUser, email: defaultEmail })
    // eslint-disable-next-line
  }, [defaultEmail])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    requestState.error && setRequestState({ error: '' })
    setNewUser({ ...newUser, [e.target.id]: e.target.value })
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (newUser.password.length < MIN_PASSWORD_LENGTH) {
      setRequestState({
        error: `Password must be at least ${MIN_PASSWORD_LENGTH} characters`
      })
      return
    }

    try {
      setIsLoading(true)

      const status = await dispatch(signup(newUser)).unwrap()
      if (status === 201) {
        navigate(`/confirm-email?addr=${newUser.email}`, {
          viewTransition: true
        })
      }
    } catch (error) {
      setRequestState({
        error: 'Error encountered processing the request'
      })
      setIsLoading(false)
    }
  }

  return (
    <>
      {isLoading ? (
        <Spinner size='full' />
      ) : (
        <main>
          <div className='main_content login_content'>
            <Logo handler={() => navigate('/', { viewTransition: true })} />
            {requestState.error && (
              <Status
                info={requestState.error}
                reset={() => setRequestState({ ...requestState, error: '' })}
              />
            )}
            <form onSubmit={handleSubmit}>
              <label htmlFor='email'>Email:</label>
              <input
                id='email'
                type='email'
                value={newUser.email}
                onChange={handleChange}
                required
                autoFocus={!defaultEmail}
              />
              <label htmlFor='password'>New password:</label>
              <div className='input_container'>
                <input
                  id='password'
                  type={`${isPasswordVisible ? 'text' : 'password'}`}
                  value={newUser.password}
                  onChange={handleChange}
                  required
                  autoFocus={!!defaultEmail}
                  ref={inputRef}
                />
                <span
                  className='material-symbols-rounded'
                  onClick={() => setIsPasswordVisible(!isPasswordVisible)}>
                  {isPasswordVisible ? 'visibility_off' : 'visibility'}
                </span>
              </div>
              <button className='submit'>Create my account</button>
            </form>
            <div>
              <span>
                Already have an account?{' '}
                <em
                  className='span-a'
                  onClick={() =>
                    navigate(`/log-in?addr=${newUser.email}`, {
                      viewTransition: true
                    })
                  }>
                  Log in
                </em>
              </span>
            </div>
          </div>
        </main>
      )}
    </>
  )
}
